import React, { PropsWithChildren } from "react";
//#region types
import { ExpandableViewPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import ViewPanelOuter from "./viewPanelOuter";
import ViewPanelTitle from "./viewPanelTitle";
import ViewPanelContent from "./viewPanelContent";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ErrorBoundary } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ExpandableViewPanel: React.FC<PropsWithChildren<ExpandableViewPanelProps>> = (props) => {
  return (
    <ViewPanelOuter
      appearance={props.appearance}
      gridSize={props.gridSize}
      fitContent={props.fitContent}
      className={props.className}
    >
      <Accordion className={cssExports.expansionViewPanel} defaultExpanded={props.expanded}>
        <AccordionSummary
          classes={{
            root: cssExports.expansionViewPanelSummary,
            content: cssExports.expansionViewPanelSummaryContent,
            expandIconWrapper: cssExports.expansionPanelIcon,
            expanded: cssExports.hiddenAmounts,
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {props.title && (
            <ViewPanelTitle
              icon={props.icon}
              title={props.title}
              description={props.description}
              topRightContent={props.topRightContent}
            ></ViewPanelTitle>
          )}
        </AccordionSummary>
        <AccordionDetails
          classes={{
            root: cssExports.expansionViewPanelDetails,
          }}
        >
          <ErrorBoundary>
            <ViewPanelContent
              isCanvasContent={props.isCanvasContent}
              classes={props.classes}
              footerLeftContent={props.footerLeftContent}
              footerRightContent={props.footerRightContent}
              footerContainerId={props.footerContainerId}
            >
              {props.children}
            </ViewPanelContent>
          </ErrorBoundary>
        </AccordionDetails>
      </Accordion>
    </ViewPanelOuter>
  );
};

export default ExpandableViewPanel;
